import axios from "@axios";

const MEMBER = (type) => `v2/directors/${type}`;
const MEMBER_BY_ID = (id, type) => `v2/directors/${type}/${id}`;
const GENERAL_AUTHORITY_BY_ID = (id) => `v2/general-authority-members/${id}`;
const GENERAL_AUTHORITY_MEETINGS_BY_ID = (id) => `v2/general-authority-meetings/${id}`;
const GENERAL_AUTHORITY = "v2/general-authority-members";
const COUNCILS = (type) => `v2/director-boards/${type}`;
const COUNCIL_BY_ID = (id, type) => `v2/director-boards/${type}/${id}`;
const DIRCTORS_BY_BOARD_ID = (id) => `v2/director-boards/administrative/${id}?type=administrative`;
const DIRCTORS_BY_BOARD_ID_AND_TYPE = (id, type) => `v2/director-boards/${type}/${id}?type=${type}`;

import * as ep from "./endpoints";
export default class Service {
  static updateMember(payload) {
    var req = new FormData();
    Object.keys(payload.form).forEach(key => { 
      if(key === 'inquiry_bulletin_file') {
        if(typeof(payload.form[key]) === 'object'){
          req.append(`${key}`, payload.form[key]);

        }
      }
      else
        req.append(`${key}`, payload.form[key]);
    }); 
    
    req.append("_method", "PUT");
    return axios
      .post(MEMBER_BY_ID(payload.form.id, payload.type), req, {
        params: { type: payload.type },
      })
      .then((res) => res);
  }
  static addMember(payload) {
    var req = new FormData();
    Object.keys(payload.form).forEach(key => {  
        req.append(`${key}`, payload.form[key]);
    }); 
    return axios
      .post(MEMBER(payload.type), req, {
        params: { type: payload.type },
      })
      .then((res) => res);
  }
  
  static fetchMemberCount(payload) {
    console.log("payload" , payload)
    return axios
      .get(DIRCTORS_BY_BOARD_ID_AND_TYPE(payload.id, payload.type))
      .then((res) => res);
  }
  static deleteMember(payload) {
    return axios
      .delete(MEMBER_BY_ID(payload.id, payload.type), {
        params: { type: payload.type },
      })
      .then((res) => res);
  }
  static updateGeneralAuthorityMember(payload) {
    return axios.put(GENERAL_AUTHORITY_BY_ID(payload.id), payload);
  }
  static addGeneralAuthorityMember(payload) {
    return axios.post(GENERAL_AUTHORITY, payload);
  }
  static deleteGeneralAuthorityMember(id) {
    return axios.delete(GENERAL_AUTHORITY_BY_ID(id));
  }
  static addCouncil(payload) {
    return axios
      .post(COUNCILS(payload.type), payload.form, {
        params: { type: payload.type },
      })
      .then((res) => res);
  }
  
  static updateCouncil(payload) {
    return axios
      .put(COUNCIL_BY_ID(payload.id, payload.type), payload.form , {
        params: { type: payload.type },
      })
      .then((res) => res);
  }
  static deleteCouncil(payload) {
    return axios
      .delete(COUNCIL_BY_ID(payload.id, payload.type), {
        params: { type: payload.type },
      })
      .then((res) => res);
  }
  static fetchCouncils(payload) {
    return axios
      .get(COUNCILS(payload.type), {
        params: { type: payload.type },
      })
      .then((res) => res);
  }
  static addEmployee(payload) {
    return axios
      .post(ep.EMPLOYEES(payload.type), payload.data)
      .then((res) => res);
  }
  static updateEmployee(payload) {
    return axios
      .put(ep.EMPLOYEE_BY_ID(payload.id, payload.type), payload.data)
      .then((res) => res);
  }
  static deleteEmployee(payload) {
    return axios
      .delete(ep.EMPLOYEE_BY_ID(payload.id, payload.type))
      .then((res) => res);
  }
  // hold-general-body-meeting
  static deleteHoldGeneralBodyMeeting(id) {
    return axios.delete(GENERAL_AUTHORITY_MEETINGS_BY_ID(id));
  }
}
